import { FETCH_PROVINCE } from '../actions/types';

const INITIAL_STATE = [];

export default function(state = INITIAL_STATE, action) {
	switch(action.type) {
		case FETCH_PROVINCE:
			return action.payload.data || [];
		default:
			return state;
	}
}
